import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import CKEditor from 'ckeditor4-react';
import $ from 'jquery';
import ReactFileReader from 'react-file-reader';
import NoIMAGE from '../assets/noimage.jpg';

const styles = {
	imgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',height : '100px'
	},
	plusImgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',backgroundColor : '#f1f1f1',cursor : 'pointer'
    },
    btnStyle: {
		position: 'absolute',
		top: '1px',
		right: '2px',
		borderRadius: '10px',
		cursor: 'pointer'
	}
}

class AddQuestion extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			acyear : this.props.acyear,
			cls : this.props.cls,
			sub : this.props.sub,
			_message : '',
            alertClass :'',
            books : [],
            lessons : [],
            files : [],
            filesname : [],
            file1 : [],
            file2 : [],
            file3 : [],
            file4 : [],
            btnText : 'Save',
			ismath : false,
			_redirect : false
		}
		this.getQusFiles = this.getQusFiles.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onBookChange = this.onBookChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
    }

    getQusFiles(files) {
       
        for (var i = 0; i < (files.base64).length; i++) {
            this.state.files.push(files.base64[i]);
            this.state.filesname.push(files.fileList[i].name);
        }
        this.setState({ files: this.state.files,filesname : this.state.filesname });
    }
    
    handleRemove(index) {
		this.state.files.splice(index, 1);
		this.state.filesname.splice(index, 1);
		this.setState({ files: this.state.files,filesname: this.state.filesname });
	}

    getFiles(name,files){
        var fname = name+'name';
		this.setState({[name] : files.base64,[fname] : files.fileList[0].name});
    }
    
    onChkChange(e){
        if(e.target.checked){
            this.setState({ismath : true});
        }
        else{
            this.setState({ismath : false});
        }
    }

    onEditorChange(name,evt) {
        this.setState({
            [name]: evt.editor.getData()
        });
    }
    
    componentWillMount(){
        this.getbooks();
    }
	
	onCancelClick(e){
        this.props.cancelClick();
	}
    
    onBookChange(e){
        this.state.book = e.target.value;
        this.setState({[e.target.name]:e.target.value});
        this.getlesson();
    }

	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** submit form **/
	onSubmit(e){
        e.preventDefault();
        
        if(this.state.question!='' && this.state.option1!='' && this.state.option2!=''){
            this.setState({btnText : 'Saving...'});
            PostData('question/addquestion',this.state).then((result) => {
                let responseJson = result;
                if(responseJson.status == '1' ){
                    this.setState({
                        _message:'Question Added Successfully!..',
                        alertClass:'alert alert-success',
                        btnText : 'Save',
                        question : '',
                        option1 : '',
                        option2 : '',
                        option3 : '',
                        option4 : ''
                    });
                    document.getElementById("addqus").reset();
                    this.props.afterFinish();
                }
                else{
            
                    this.setState({
                        _message:'Invalid Key',
                        alertClass:'alert alert-danger'
                    });
                }
            });
        }
        else{
            alert('Please fill all mandatory field. Mandatory fields are marked as *');
        }
	}
    
    getbooks() {
		$("#showLoader").show();
		GetData('question/getbooks').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					books: responseJson
				});
			}
		});
	}
    
    getlesson() {
		$("#showLoader").show();
		GetData('question/getlessonsforquestion/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.sub+'/'+this.state.book).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					lessons: responseJson
				});
			}
		});
	}

    render() {
    
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state.userId = userData['userid'];
    
    return (
        <div>
            <form action="" method="post" role="form" id="addqus" encType="multipart/form-data" onSubmit={this.onSubmit} >
            <Row>
                <div style={{position: 'absolute',top: '-46px',right: '160px'}}>
                    <label class="switch switch-text switch-pill switch-success">
                        <input type="checkbox" class="switch-input" checked={this.state.ismath} onClick={this.onChkChange} />
                        <span class="switch-label" data-on="On" data-off="Off"></span>
                        <span class="switch-handle"></span>
                    </label>&nbsp;
                    <span>Math Editor</span>
                </div>
                <Col md="6">
                    <FormGroup>
                        <Label>Book <span className="text-danger">*</span></Label>
                        <select name="book" onChange={this.onBookChange} id="book" className="form-control" required > 
                            {
                                this.state.books.map(function (item) {
                                    return <option value={item.id}>{item.book}</option>;
                                })
                            }
                        </select>
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Lesson <span className="text-danger">*</span></Label>
                        <select name="lesson" onChange={this.onChange} id="lesson" className="form-control" required > 
                            <option value="">Select Lesson</option>
                            {
                                this.state.lessons.map(function (item) {
                                    return <option value={item.id}>{item.lesson}</option>;
                                })
                            }
                        </select>
                    </FormGroup>
                </Col>
                <Col md="12">
                    <FormGroup>
                        <Label style={{width : '100%'}}>Question <span className="text-danger">*</span>
                            <span style={{float : 'right'}}>
                                <ReactFileReader fileTypes={[".png", ".jpg", ".jpeg"]} multipleFiles={true} base64={true} handleFiles={this.getQusFiles}>
                                    <Button type="button" color="info" size="sm"><i className="fa fa-plus"></i>&nbsp;Add Image</Button>
                                </ReactFileReader>
                            </span>
                        </Label>
                        {this.state.ismath ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'question')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.state.question} /> :
                        <textarea name="question" className="form-control" onChange={this.onChange} required /> }
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                {this.state.files.map((item, i) => {
                    return (<Col md={2}>
                        <img src={item} width="100px" style={styles.imgStyle} />
                        <button type="button" className="btn btn-danger btn-sm" style={styles.btnStyle} onClick={this.handleRemove.bind(this, i)}><i className="fa fa-remove"></i></button>
                    </Col>);
                })}
            </Row>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 1 <span className="text-danger">*</span></Label>
                        {this.state.ismath ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option1')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.state.option1} /> :
                        <textarea name="option1" className="form-control" onChange={this.onChange} required={this.state.file1.length > 0 ? false : true} /> }
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 2 <span className="text-danger">*</span></Label>
                        {this.state.ismath ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option2')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.state.option2} /> :
                        <textarea name="option2" className="form-control" onChange={this.onChange} required={this.state.file2.length > 0 ? false : true} /> }
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 3</Label>
                        {this.state.ismath ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option3')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.state.option3} /> :
                        <textarea name="option3" className="form-control" onChange={this.onChange} /> }
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 4</Label>
                        {this.state.ismath ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option4')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.state.option4} /> :
                        <textarea name="option4" className="form-control" onChange={this.onChange} /> }
                    </FormGroup>
                </Col>
                <Col md="3">
                    <Label>Option 1 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file1')}>
                        <img src={this.state.file1.length > 0 ? this.state.file1 : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <Label>Option 2 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file2')}>
                        <img src={this.state.file2.length > 0 ? this.state.file2 : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <Label>Option 3 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file3')}>
                        <img src={this.state.file3.length > 0 ? this.state.file3 : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <Label>Option 4 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file4')}>
                        <img src={this.state.file4.length > 0 ? this.state.file4 : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Answer <span className="text-danger">*</span></Label>
                        <select name="answer" class="form-control" onChange={this.onChange} required>
                            <option value="">Select Answer</option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                            <option value="option4">Option 4</option>
                        </select>
                    </FormGroup>
                </Col>
                <Col md="9">
                    <FormGroup>
                        <Label>Explanation</Label>
                        <textarea name="explanation" className="form-control" onChange={this.onChange} />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>Create by</Label>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Input type="text" name="createby" onChange={this.onChange} />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Button type="submit" color="primary" style={{float : 'right'}} disabled={this.state.btnText == 'Save' ? false : true}>{this.state.btnText}</Button>&emsp;
                        <Button color="danger" style={{float : 'right'}} onClick={this.onCancelClick.bind(this)}>Cancel</Button>&emsp;
                    </FormGroup>
                </Col>
            </Row>
            </form>
        </div>
	);
  }
}

export default AddQuestion;



// WEBPACK FOOTER //
// ./src/Questions/AddQuestion.js